import React from "react";
import SubHeader from "../components/header/SubHeader";
import Stack from "../components/ui/Stack";
import ProfileInfo from "../components/profile/ProfileInfo";
import ProfileTab from "../components/profile/ProfileTab";
import {useSelector} from "react-redux";
const Profile = () => {
    const {
        fetchUserStatus,
        error
    } = useSelector((state) => state.auth);
    return (
        <>
            <SubHeader title="Profile" />
            {fetchUserStatus === "loading" && <p>Loading...</p>}
            {fetchUserStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchUserStatus === "success" && (
                <Stack className="gap-5 flex-column flex-lg-row">
                    <div className="flex-340 p-4 border rounded-2">
                        <ProfileInfo />
                    </div>
                    <div className="w-100">
                        <ProfileTab/>
                    </div>
                </Stack>
            )}

        </>
    );
}
export default Profile;
